export const SelectedCustomFieldsModel = Symbol('SelectedCustomFieldsModel');
